import * as React from "react";
import { useTranslation } from "react-i18next";
import { Fragment,useEffect, useMemo, useState } from "react";
import { translateSubElementString } from "../../../../../../../utils";
import CategoryPreviewWrapper from "./CategoryPreviewWrapper";
import { DataTable } from "../../../../../../../components/DataTable";
import { Box, Flex, Grid, GridItem, Heading, Text } from "@chakra-ui/react";
import { NumberField } from "../../../../../../../components/NumberField";

function EmployeeCommutingPreview({ currentElement: { items, transportModes, totalCo2Emissions } }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "reportsPage.scopeThree.inputs.employeeCommuting"
  });
  const questionnaireKeyPrefix = "organizationQuestionnaire.scope3.inputs";
  const { t: inputsTranslation, i18n } = useTranslation("translation", {
    keyPrefix: questionnaireKeyPrefix
  });

  const [employeeCommutingData, setEmployeeCommutingData] = useState([]);

  useEffect(() => {
    if (items) {
      setEmployeeCommutingData(items.map(item => {
        return {
          modeOfTransport: item.modeOfTransport && item.modeOfTransport !== "" ?
            inputsTranslation(`modeOfTransportOptions.${item.modeOfTransport}`) : "",
          transportSubtype: item.transportSubtype && item.transportSubtype !== "" ?
            // Temporary fix for empty subtype field of the following two transport modes
            item.modeOfTransport !== "walking" && item.modeOfTransport !== "cycling" ?
            inputsTranslation(`transportSubtypeOptions.${item.modeOfTransport}.${item.transportSubtype}`) : "" : "",
          emissions: item.totalEmission
        };
      }));
    }
  }, [items, inputsTranslation]);

  const columns = useMemo(
    () => [
      {
        header: t("modeOfTransport"),
        accessorKey: "modeOfTransport",
        size: 200
      },
      {
        header: t("transportSubtype"),
        accessorKey: "transportSubtype",
        size: 300
      },
      {
        header: translateSubElementString("reportsPage.scopeThree.inputs.employeeCommuting.emissions"),
        accessorKey: "emissions",
        size: 150
      }
    ],
    [t]
  );

  return (
    <CategoryPreviewWrapper>
      <Flex marginBlockEnd={4}>
        <Text size="sm" fontWeight="bold">
          {translateSubElementString(
            "reportsPage.scopeThree.inputs.mainTotalEmissions"
          )}
        </Text>
        <NumberField value={totalCo2Emissions} marginStart="2" />
      </Flex>
      <DataTable
        data={employeeCommutingData}
        columns={columns}
        marginBlockEnd={8}
        containerHeight={employeeCommutingData && employeeCommutingData.length > 0 ? "300px" : null}
      />
      {transportModes && transportModes.length > 0 &&
        <Grid templateColumns="repeat(2, 1fr)" gap={2} overflow="auto">
          <GridItem>
            <Heading size="sm" marginBlock="1" align="left">
              {t("modeOfTransport")}
            </Heading>
          </GridItem>
          <GridItem>
            <Heading size="sm" marginBlock="1" align="right">
              {translateSubElementString("reportsPage.totalEmissions")}
            </Heading>
          </GridItem>
          {transportModes && transportModes.map(item => {
            return <Fragment key={`transportMode-${item.id}`}>
              <GridItem>
                <Box inlineSize="400px">
                  <Text
                    display="flex"
                    justifyContent="start"
                    alignItems="center"
                    fontSize="sm"
                    whiteSpace="break-spaces"
                    marginLeft={6}
                  >
                    {i18n.exists(`${questionnaireKeyPrefix}.modeOfTransportOptions.${item.modeOfTransport ?? ""}`) ?
                      inputsTranslation(`modeOfTransportOptions.${item.modeOfTransport}`) : item.modeOfTransport ?? ""}
                  </Text>
                </Box>
              </GridItem>
              <GridItem>
                <NumberField value={item.co2Emissions} />
              </GridItem>
            </Fragment>;
          })}
        </Grid>
      }
    </CategoryPreviewWrapper>
  );
}

export default EmployeeCommutingPreview;